import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EOpenNewReviewForm {
  Open = 'NEW_REVIEW/FORM/OPEN',
  Close = 'NEW_REVIEW/FORM/CLOSE',
}

export type TOpenNewReview = ITypedReduxAction<EOpenNewReviewForm.Open>;
export type TCloseNewReview = ITypedReduxAction<EOpenNewReviewForm.Close>;

export type TOpenNewReviewFormActions = TOpenNewReview | TCloseNewReview;
